import React, { useState } from 'react';
import NewsletterSignup from './NewsletterSignup';
import { Link } from 'react-router-dom';


function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Integrate with Mailchimp, ConvertKit, or backend API
    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer style={{
      backgroundColor: '#121212',
      color: '#ccc',
      padding: '2rem',
      textAlign: 'center',
      marginTop: '4rem',
      fontSize: '0.9rem'
    }}>
        <NewsletterSignup></NewsletterSignup>

      <div style={{ marginBottom: '0.5rem' }}>
        &copy; {new Date().getFullYear()} Meshum. All rights reserved.
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
       <Link to="/about" style={{ color: "#ccc" }}>About</Link>
       <Link to="/terms-of-use" style={{ color: "#ccc" }}>Terms of Use</Link>
        <Link to="/privacy-policy" style={{ color: "#ccc" }}>Privacy Policy</Link>
        <Link to="mailto:contact@meshum.com" style={linkStyle}>Contact</Link>
      </div>
    </footer>
  );
}

const linkStyle = {
  color: '#bbb',
  textDecoration: 'none',
  fontWeight: 500
};

export default Footer;
